// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2tkRN","col":"styles_col__-2XsM"};